import React from 'react';

interface IconPlayProps {
    iconClasses?: string;
}

const IconPlay: React.FC<IconPlayProps> = ({ iconClasses }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-play ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M3.5 2.8v10.4c0 .7.8 1.1 1.4.7l8.2-5.2c.5-.3.5-1.1 0-1.4L4.9 2.1c-.6-.4-1.4 0-1.4.7Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconPlay;
